/* eslint-disable */
import { useQuery } from 'vue-query';
import apiAxios from '../../apiAdminAxios';

const fetchCampaigns = async ({ page }) => {
  let URL = `?page=${page || 1}`;

  const { data } = await apiAxios.get(`/admin/campaigns${URL}`);
  return data;
};

const createCampaign = async ({ name, emails }) => {
  const { data } = await apiAxios.post(`/admin/campaigns/create`, {
    name,
    emails,
  });
  return data;
};


const sendSample = async ({ id }) => {
  const { data } = await apiAxios.post(`/admin/campaigns/${id}/send-sample`);
  return data;
};



// returns the batches the backend would create for this start time, without saving anything
const previewCampaignSchedule = async ({ campaignId, startAt }) => {
  const { data } = await apiAxios.post(`/admin/campaigns/${campaignId}/schedule-preview`, {
    start_at: startAt,
  });
  return data;
};

const scheduleCampaign = async ({ campaignId, startAt }) => {
  const { data } = await apiAxios.post(`/admin/campaigns/${campaignId}/schedule`, {
    start_at: startAt,
  });
  return data;
};


const deleteCampaign = async ({ id }) => {
  const { data } = await apiAxios.post(`/admin/campaigns/${id}/delete`);
  return data;
};

const getCampaignById = async ({ id }) => {
  const { data } = await apiAxios.get(`/admin/campaigns/${id}`);
  return data;
};

// queries
const useCampaignsQuery = ({ page }) =>
  useQuery(['admin/campaigns', page], () => fetchCampaigns({ page }), { refetchOnMount: true });

export default {
  // queries
  createCampaign,
  useCampaignsQuery,
  previewCampaignSchedule,
  scheduleCampaign,
  deleteCampaign,
  getCampaignById,
  sendSample,
};
